'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _imgBase = require('./img-base');

var _imgBase2 = _interopRequireDefault(_imgBase);

var _omitInternalProps = require('./omit-internal-props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Img = _react2.default.forwardRef(function (props, ref) {
  return _react2.default.createElement(_imgBase2.default, _extends({}, props, {
    render: function render(_ref) {
      var src = _ref.src;
      return _react2.default.createElement('img', _extends({ src: src, className: props.className, style: props.style, ref: ref }, (0, _omitInternalProps.omitInternalProps)(props)));
    }
  }));
});

Img.propTypes = _extends({}, _imgBase2.default.interfacePropTypes, {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object
});

exports.default = Img;